import {inject, observer} from 'mobx-react';
import qs from 'qs';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Container} from 'reactstrap';
import {from} from 'rxjs';
import {getCertadocFineReport} from '../../services/reportService';
import CertadocFineList from '../../views/reports/certadoc-fine-list';

const CertadocFineReportContainer = ({location}) => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);

  const search = useMemo(() => location.search, [location.search]);

  const getReport = useCallback((params) => {
    setLoading(true);
    from(getCertadocFineReport(params)).subscribe(
        (data) => {
          setReport(data);
          setLoading(false);
        },
        () => {
          setReport([]);
          setLoading(false);
        },
    );
  }, []);

  useEffect(() => {
    if (search && location.hash === '#certadocfines') {
      const params = qs.parse(search, {
        ignoreQueryPrefix: true,
        comma: true,
      });

      getReport(qs.stringify(params, {indices: false}));
    }
  }, [search]);

  return (
    <Container fluid className="px-4 position-relative h-100">
      <CertadocFineList data={report} loading={loading} />
    </Container>
  );
};

const mapping = ({store}) => ({
  auth: store.auth,
  session: store.session,
});

export default inject(mapping)(observer(CertadocFineReportContainer));
